import { Col, Form, Input, Row } from "antd";
import React from "react";
import { FormItemHiddenUi } from "../../../ui/FormItemHiddenUi";
import { SwitchUi } from "../../../ui/SwitchUi";

export const ModuloForm = () => {
  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <Form.Item
            label="Nombre"
            name="nombre"
            rules={[
              {
                required: true,
                message: "El nombre de módulo es obligatorio",
              },
            ]}
          >
            <Input placeholder="Nombre de módulo" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24}>
          <Form.Item label="Estado" name="state" valuePropName="checked">
            <SwitchUi />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
